import React, { ReactElement } from 'react';
import { Text } from '@feast-it/ui/light';
import { Breadcrumb, Container, StyledLink } from './Breadcrumbs.styled';
import { BreadcrumbsPropsV2 } from './types';
import { PATHS } from '../../../constants/paths';
import { basePath } from '../../../../config';
import { BREADCRUMB_CLICKED } from '../../../constants/analytics';
import { trackEvent } from '../../../modules/analytics';
import { useRouter } from 'next/router';
import { getAbsoluteUrl } from '@/helpers/formatUrl';
import { useIsDarkTheme } from '../../../context/DarkThemeContext';

export function BreadcrumbsV2({
  breadcrumbs,
}: BreadcrumbsPropsV2): ReactElement {
  const router = useRouter();
  const isDark = useIsDarkTheme();

  return (
    <Container>
      <Breadcrumb isDark={isDark}>
        <StyledLink isDark={isDark} href={PATHS.home}>
          Togather
        </StyledLink>
        <span>/</span>
      </Breadcrumb>
      {breadcrumbs.map((breadcrumb, index) =>
        breadcrumb.displayAsLink ? (
          <Breadcrumb isDark={isDark} key={`${breadcrumb?.text}-${index}`}>
            <StyledLink
              isDark={isDark}
              href={`${basePath}/${breadcrumb.url}`}
              onClick={() =>
                trackEvent(BREADCRUMB_CLICKED, {
                  label: breadcrumb.text,
                  destinationUrl: `${getAbsoluteUrl(breadcrumb.url)}`,
                  currentPage: getAbsoluteUrl(router.asPath),
                  order: index + 1,
                })
              }
            >
              {breadcrumb.text}
            </StyledLink>

            <span>/</span>
          </Breadcrumb>
        ) : (
          <Text
            key={`${breadcrumb?.text}-${index}`}
            style="bodyBoldMedium"
            color={isDark ? 'white' : 'black'}
          >
            {breadcrumb.text}
          </Text>
        )
      )}
    </Container>
  );
}
